// extracted by mini-css-extract-plugin
export var grabACopyBlockContainer = "styles-module--grabACopyBlockContainer--1NeJ3";
export var grabACopyBlockImageContainer = "styles-module--grabACopyBlockImageContainer--1X34p";
export var grabACopyBlockTextOuterContainer = "styles-module--grabACopyBlockTextOuterContainer--4Uv-5";
export var grabACopyBlockTextInnerContainer = "styles-module--grabACopyBlockTextInnerContainer--32Ddk";
export var text = "styles-module--text--1a7hI";
export var downloadIcon = "styles-module--downloadIcon--VxFdz";
export var grabACopyBlockImage = "styles-module--grabACopyBlockImage--15Bjz";
export var buttonContainer = "styles-module--buttonContainer--1ZUtd";
export var button = "styles-module--button--R8l2f";